module.exports = __webpack_public_path__ + "static/media/zhongjieshangjia@2x.d939ae95.png";